import request from '@/utils/request'

let urbanApi = {

  /*城建招标列表*/
  list(data) {
    return request._post('/shop/plus.urban.Index/index', data);
},

getCategory(data){
     return request._post('/shop/plus.urban.Index/getCategory', data);
},
/*添加城建招标*/
add(data) {
    return request._post('/shop/plus.urban.Index/add', data);
},
/*修改城建招标*/
edit(data) {
    return request._post('/shop/plus.urban.Index/edit', data);
},
/*删除城建招标*/
del(data) {
    return request._post('/shop/plus.urban.Index/del', data);
},
/*城建招标详情*/
detail(data) {
  return request._post('/shop/plus.urban.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.urban.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.urban.Setting/getSetting', data, errorback);
    },
}
export default urbanApi;



// WEBPACK FOOTER //
// ./src/api/urban.js